(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PackageFeatureListCustom', PackageFeatureListCustom);

    PackageFeatureListCustom.$inject = ['$resource'];

    function PackageFeatureListCustom($resource) {


        var getPackageFeatureListByCompanyId = function (companyId) {
            var resourceUrl = 'api/get-package-feature-list-by-company-id?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }
        var getPackageFeatureListByCurrentCompany = function () {
            var resourceUrl = 'api/get-package-feature-list-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        return {
            getPackageFeatureListByCompanyId: getPackageFeatureListByCompanyId,
            getPackageFeatureListByCurrentCompany: getPackageFeatureListByCurrentCompany

        };
    }
})();
